module.exports = __webpack_public_path__ + "img/artist-submits.a1e10208.webp";